// Widget Scripts
import customPopUp from './js/widgets/customPopUp.js';
import themeBackground from './js/widgets/0-themeBackground.js';
import customTicketButton from './js/widgets/1-customTicketButton.js';
import mainSlideshow from './js/widgets/2-mainSlideshow.js';
import * as eventsWidget from './js/widgets/3-events-widget/index.js';

import renderSlideshows from './js/widgets/4-multiple-slideshows/index.js';

import customCards from './js/widgets/5-customCards.js';
import * as seoSignup from './js/widgets/6-seo-signup/index.js';
import scrollerSponsors from './js/widgets/7-scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeBackground();
  customTicketButton();
  customPopUp('homepage');

  if (globalThis.location.pathname === '/') {
    mainSlideshow();
    // eventsWidget.autoEventFeed();
    eventsWidget.manualEventFeed();
    renderSlideshows();
    customCards();
    seoSignup.customSeoBlock();
    seoSignup.customSignup();
    scrollerSponsors();
  }
});
